(function () {
  'use strict';

  function initExpandableForm() {
    if (!/\/pages\/b2b-sign-up\/?$/i.test(window.location.pathname)) return;

    var targetSection = document.querySelector('#b2b-form');
    if (!targetSection || targetSection.dataset.expandableReady === 'true') return;

    targetSection.dataset.expandableReady = 'true';
    targetSection.style.position = 'relative';
    targetSection.style.overflow = 'hidden';
    targetSection.style.transition = 'height 0.4s ease';

    var collapsedHeight = 520;
    var isExpanded = false;
    targetSection.style.height = collapsedHeight + 'px';

    var toggleButton = document.createElement('button');
    toggleButton.type = 'button';
    toggleButton.className = 'scrl-btn';
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.setAttribute('aria-controls', 'b2b-form');

    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('class', 'arrow-icon');
    arrow.setAttribute('width', '16');
    arrow.setAttribute('height', '16');
    arrow.setAttribute('viewBox', '0 0 24 24');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';

    var label = document.createElement('span');
    label.textContent = 'Show the full application';
    toggleButton.appendChild(arrow);
    toggleButton.appendChild(label);
    targetSection.insertAdjacentElement('afterend', toggleButton);

    toggleButton.addEventListener('click', function () {
      isExpanded = !isExpanded;
      targetSection.style.height = isExpanded ? targetSection.scrollHeight + 'px' : collapsedHeight + 'px';
      label.textContent = isExpanded ? 'Collapse application' : 'Show the full application';
      arrow.classList.toggle('rotate', isExpanded);
      toggleButton.setAttribute('aria-expanded', String(isExpanded));
    });
  }

  function initTestimonials() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.testimonial-right .tab:not(.empty)'));
    var items = Array.prototype.slice.call(document.querySelectorAll('.testimonial-item'));
    var arrowUp = document.querySelector('.top-arrow');
    var arrowDown = document.querySelector('.bottom-arrow');
    if (!tabs.length || !items.length) return;

    var visibleCount = 4;
    var startIndex = 0;

    function updateVisibleTabs() {
      tabs.forEach(function (tab, index) {
        tab.style.display = index >= startIndex && index < startIndex + visibleCount ? 'flex' : 'none';
      });
    }

    function showTestimonial(index) {
      if (!items[index] || !tabs[index]) return;
      items.forEach(function (item) { item.classList.remove('active'); });
      tabs.forEach(function (tab) { tab.classList.remove('active'); });
      items[index].classList.add('active');
      tabs[index].classList.add('active');
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { showTestimonial(index); });
    });

    if (arrowUp) {
      arrowUp.addEventListener('click', function () {
        if (startIndex > 0) startIndex -= 1;
        updateVisibleTabs();
      });
    }

    if (arrowDown) {
      arrowDown.addEventListener('click', function () {
        if (startIndex + visibleCount < tabs.length) startIndex += 1;
        updateVisibleTabs();
      });
    }

    updateVisibleTabs();
  }

  function initFaqs() {
    document.querySelectorAll('.partner-faq-sec').forEach(function (section) {
      var items = Array.prototype.slice.call(section.querySelectorAll('.newFaq-item'));

      items.forEach(function (item) {
        var button = item.querySelector('.newFaq-question');
        var answer = item.querySelector('.newFaq-answer');
        if (!button || !answer) return;

        button.addEventListener('click', function () {
          var shouldOpen = button.getAttribute('aria-expanded') !== 'true';

          items.forEach(function (candidate) {
            var candidateButton = candidate.querySelector('.newFaq-question');
            var candidateAnswer = candidate.querySelector('.newFaq-answer');
            candidate.classList.remove('active');
            if (candidateButton) candidateButton.setAttribute('aria-expanded', 'false');
            if (candidateAnswer) candidateAnswer.hidden = true;
          });

          if (shouldOpen) {
            item.classList.add('active');
            button.setAttribute('aria-expanded', 'true');
            answer.hidden = false;
          }
        });
      });
    });
  }

  function init() {
    initExpandableForm();
    initTestimonials();
    initFaqs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
